export default __webpack_public_path__ + "static/media/info-mail.2d1e0126.svg";